<template>
    <div class="app-profile">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Meus dados</mu-title>

        <br>

        <mu-paper class="form" :z-depth="1">
            <mu-form :model="form">

                <mu-row gutter>
                    <mu-col span="12" sm="12" md="8" lg="8" xl="8">

                        <mu-row gutter>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <!-- Nome -->
                                <mu-text-field v-model="form.firstName" full-width label="Nome"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <!-- Sobrenome -->
                                <mu-text-field v-model="form.lastName" full-width label="Sobrenome"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <!-- E-mail -->
                                <mu-text-field v-model="form.email" full-width label="E-mail"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <!-- Login -->
                                <mu-text-field v-model="form.userName" disabled full-width label="Login"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <!-- Senha -->
                                <mu-text-field v-model="form.password" @focus="verifyFocus()" @blur="verifyFocus()" full-width label="Senha" type="password"></mu-text-field>
                                <small class="info-form" v-if="passFocus">A senha deve ter pelo menos 6 caracteres e ser composta por letras maiúsculas, minúsculas e números!</small>
                            </mu-col>
                            <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                                <!-- Confirme a senha -->
                                <mu-text-field v-model="form.passwordConfirmation" full-width label="Confirme a senha" type="password"></mu-text-field>
                            </mu-col>
                        </mu-row>

                    </mu-col>
                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">

                        <!-- Atalhos -->
                        <div class="infos">
                            <mu-button color="secondary" large @click="dialogShortcuts(true)">
                                <font-awesome-icon icon="star" class="icon-margin-left icon-margin-bottom"/>
                                Escolher Favoritos
                            </mu-button>
                            <br>
                            <mu-favorite v-for="(item, key) in shortcutsList" :key="key" :favorite="item"></mu-favorite>
                        </div>

                        <mu-dialog title="Favoritos do Dashboard" width="450" scrollable :overlay-close="false" :esc-press-close="false" :open.sync="shortcuts.openDialog">
                            <mu-alert class="alert-info">
                                <font-awesome-icon icon="exclamation-triangle" class="icon-md icon-margin-left"/>
                                Selecione as áreas que você mais acessa no sistema e deixe como atalhos em seu Dashboard, dessa forma terá um acesso rápido. Você pode selecionar até 4 atalhos.
                            </mu-alert>
                            <div>
                                <!-- Lista de itens disponíveis no menu -->
                                <span v-for="item in menu" :key="item.key">
                                    <div v-if="item.childrens.length > 0" class="service">
                                        <mu-title type="h3" color="secondary">{{ item.title }}</mu-title>
                                        <div class="itens" v-for="i in item.childrens" :key="i.key">
                                            <div v-if="checkPermition(i)">
                                                <mu-checkbox v-model="shortcuts.itens" :value="i.key" :label="i.title"></mu-checkbox><br>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div slot="actions" v-if="shortcuts.itens.length > 4">
                                <mu-alert color="error">
                                      <font-awesome-icon icon="exclamation-circle" class="icon-md icon-margin-left"/>
                                    Atenção! Você pode escolher apenas 4 favoritos para adicionar ao seu Dashboard.
                                </mu-alert>
                            </div>
                            <mu-button slot="actions" color="primary" round @click="dialogShortcuts(false)" v-if="shortcuts.itens.length <= 4">
                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                OK
                            </mu-button>
                        </mu-dialog>

                    </mu-col>
                </mu-row>

                <mu-button round color="primary" @click="saveForm()">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Salvar
                </mu-button>

            </mu-form>
        </mu-paper>

    </div>
</template>

<script>
    import Menu from '@/config/menu'
    import ProfileServices from '@/services/profile/user'

    export default {
        name: 'app-profile',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                menu: Menu.data,
                form: {},
                ignoreCustomTypeClient: [
                    'app.settings.clients',
                    'app.settings.users',
                    'app.settings.credits'
                ],
                shortcuts: {
                    openDialog: false,
                    itens: []
                },
                passFocus: false
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Chamamos o loadForm para carregar os dados do profile assim
         * que o componente for criado
         */
        created () {
            this.loadForm()
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Retorna a lista do menu em um array organizado com map
             */
            shortcutsList () {
                let array = []
                this.menu.map((item) => {
                    item.childrens.map((i) => {
                        if (this.shortcuts.itens.includes(i.key)) {
                            array.push(i)
                        }
                    })
                })
                return array
            },

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            verifyFocus () {
                this.passFocus = !this.passFocus
            },

            /**
             * Carrega os dados do usuário
             */
            async loadForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando seus dados.')

                    let result = await ProfileServices.find()

                    if (result && result.status) {
                        this.form = result.results
                        this.shortcuts.itens = JSON.parse(this.form.shortcuts)
                        this.form.shortcuts = JSON.parse(this.form.shortcuts)
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Salva os dados do usuário
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando seus dados.')

                    this.form.shortcuts = JSON.stringify(this.shortcuts.itens)

                    let result = await ProfileServices.update(this.form)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$store.dispatch('updateUser', result.results)
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Método responsável por abrir o DIALOGO(Modal) e fechar, passando
             * o parametro status (boolean)
             */
            dialogShortcuts (status) {
                this.shortcuts.openDialog = status
            },

            /**
             * Método para verificar se o usuário logado e empresa podem visualizar ou adicionar
             * determinados itens do menu
             */
            checkPermition (item) {
                if (this.ignoreCustomTypeClient.includes(item.route) && this.$store.state.company.customType === 'C') {
                    return false
                }
                return item.permition.includes(this.$store.state.user.permition)
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .favorite
        margin 5px 0

    .mu-alert
        font-size 12px

    .alert-info
        background lighten($grey, 70%)
        font-size 12px
        color darken($grey, 20%)
        padding 15px

    .app-profile

        .form
            padding 20px

            .infos
                background #eee
                padding 20px;
                border-radius 4px
                border-top 2px $secondary solid
                margin-bottom 20px

                .mu-button
                    width 100%
                    margin-bottom 5px
            .mu-input
                margin-bottom 0

    .info-form
        color $primary
        font-size 11px
        margin-bottom 20px
        display block
</style>
